exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3W7y{display:block;position:relative;float:left;width:100%}", ""]);

// exports
exports.locals = {
	"root": "_3W7y",
	"root": "_3W7y"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"camelCase":true,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:4]","minimize":true}!../~/postcss-loader?pack=default!./components/ServiceAccueil/ServiceAccueil.css
// module id = 191
// module chunks = 0